import React, { useEffect, useState, useContext } from "react";
import "./AllTerrain.css";
import axios from "axios";
import { LanguageContext } from "../../context/LanguageContext";

  const API_BASE = process.env.REACT_APP_API_BASE_URL;

const AllTerrain = () => {
  const { currentLang } = useContext(LanguageContext);
  const [terrain, setTerrain] = useState(null);
  const [loading, setLoading] = useState(true);


useEffect(() => {
  const fetchTerrain = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${API_BASE}/api/allterrainsection?lang=${currentLang}`
      );
      setTerrain(res.data);
    } catch (err) {
      console.error("Error fetching AllTerrain data:", err);
    } finally {
      setLoading(false);
    }
  };

  fetchTerrain();
}, [currentLang]);

if (loading) {
  return <div className="all-terrain-loading">Loading...</div>;
}

if (!terrain) {
  return <div className="all-terrain-error">No All-Terrain data found.</div>;
}

const getImage = (url) => {
  if (!url) return "";
  return url.startsWith("http") ? url : `${API_BASE}${url}`;
};


  return (
    <>
      <section className="all-terrain">
        <div className="terrain-header">
          <h1>{terrain.title}</h1>
        </div>

        <div className="terrain-grid">

          <div className="terrain-left">
         
            <div className="terrain-block">
              <div className="terrain-text">
                <h2>{terrain.unstoppable.title}</h2>
                <p>{terrain.unstoppable.text}</p>
              </div>
              <video
                src={require("../../assets/videos/allTerrain.mp4")}
                className="terrain-media"
                autoPlay
                muted
                loop
                playsInline
              />
            </div>

      
            <div className="terrain-block">
              <img
                src={getImage(terrain.images.image2)}
                alt="Terrain Image 2"
                className="terrain-media"
              />
            </div>

        
            <div className="terrain-block">
              <video
                src={require("../../assets/videos/allTerrain2.mp4")}
                className="terrain-media"
                autoPlay
                muted
                loop
                playsInline
              />
              <div className="terrain-text">
                <h2>{terrain.crab.title}</h2>
                <p>{terrain.crab.text}</p>
              </div>
            </div>
          </div>

 
          <div className="terrain-right">
    
            <div className="terrain-block">
              <div className="terrain-text">
                <h2>{terrain.tougher.title}</h2>
                <p>{terrain.tougher.text}</p>
              </div>
              <img
                src={getImage(terrain.images.image1)}
                alt="Terrain Image 1"
                className="terrain-media"
              />
            </div>

            <div className="terrain-block">
              <img
                src={getImage(terrain.images.image3)}
                alt="Terrain Image 3"
                className="terrain-media"
              />
              <div className="terrain-text">
                <h2>{terrain.rear.title}</h2>
                <p>{terrain.rear.text}</p>
              </div>
            </div>

   
            <div className="terrain-block">
              <img
                src={getImage(terrain.images.image4)}
                alt="Terrain Image 4"
                className="terrain-media"
              />
            </div>
          </div>
        </div>
      </section>

      <div className="allTerrain-fullImg"></div>
    </>
  );
};

export default AllTerrain;
